import axios from "axios";
import { Capacitor } from "@capacitor/core";
import { getCachedToken } from "./nativeAuth";
import { makeGatewayAdapter, configureGateway } from "./local/gateway";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const attachBearer = (config) => {
  if (Capacitor.isNativePlatform()) {
    const token = getCachedToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
};

// rawApi = real network (native calls go through the OS HTTP stack via CapacitorHttp).
// Used by the local-first gateway, seed and outbox — it has NO gateway adapter, so there
// is no recursion.
export const rawApi = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });
rawApi.interceptors.request.use(attachBearer);

// api = what the app uses. On web it is a plain network client (cookie session). On native
// its adapter is the local-first gateway (local reads/writes + outbox), falling through to
// rawApi for everything else.
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use(attachBearer);

if (Capacitor.isNativePlatform()) {
  configureGateway({ net: rawApi });
  api.defaults.adapter = makeGatewayAdapter();
}

export const BACKEND = BACKEND_URL;

// Server rejected the session (expired/invalid token). Network failures have no response.
export const isAuthError = (e) => e?.response?.status === 401;

export const RETURN_TO_KEY = "molaroo.returnTo";

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong. Please try again.";
}
